import { Empty, EmptyContent, EmptyDescription, EmptyHeader, EmptyMedia, EmptyTitle } from "@cmde/shadcn";
import { TrophyIcon } from "lucide-react";
import { useTranslation } from "react-i18next";

export function EmptyCustomersList() {
  const { t } = useTranslation();

  return (
    <Empty className="border border-solid bg-white/30">
      <EmptyHeader>
        <EmptyMedia variant="icon">
          <TrophyIcon />
        </EmptyMedia>
        <EmptyTitle>{t("customers.list.messages.empty_title")}</EmptyTitle>
        <EmptyDescription>
          {t("customers.list.messages.empty_description")}
        </EmptyDescription>
      </EmptyHeader>
      <EmptyContent />
    </Empty>
  );
}
